import React from "react";
import URL from "../../../../constant/URL";
import { useTranslation } from "react-i18next";
import {withRouter} from "react-router-dom";
import lottie from "lottie-web";
import useLearningData from "../../../../hooks/useLearningData";
import useSound from "../../../../hooks/useSound";
import { useEffect } from "react";

const CompleteLoading = withRouter((props) => {

  const { t } = useTranslation();
  const { learningData, setLearningData } = useLearningData();
  const { setSound, playSound, clearSound } = useSound();

  useEffect(() => {
    window.addEventListener("backgroundApp", (e) => {
      // console.log("##### backgroundApp : ", e);
      clearSound();
    });
  }, []);

  const renderLottie = () => {
    let url = `${ process.env.PUBLIC_URL }/static/json/img_lc_03_03.json`;
    let id = 'completeLoading';

    setSound( {
      src : `${ process.env.PUBLIC_URL }/static/audio/lc_03_03.ogg`,
      loop : true
    } );
    playSound();
    let data = {
      container: document.getElementById(id),
      path : url,
      renderer: 'svg',
      loop: true,
      autoplay: true
    };

    lottie.loadAnimation(data);

    setTimeout(()=>{
      clearSound();
      setLearningData({nextLevel: ''});
      props.history.replace({
        pathname: URL.COURSE_LEARNING.LIST,
      });
    }, 2000);

  };

  React.useEffect(renderLottie, []);

  return (
    <div className="layout-def theme-white layout-lc">
      <div className="container">
        <div className="inner">
          <div className="next_lev">
            <div className="anim-wrap" id="completeLoading"></div>
            <p>LV{learningData?.nextLevel} {t("LC_03_03.msg012")}</p>
          </div>
        </div>
      </div>
    </div>
  );

});

export default CompleteLoading;


